import React from "react";
import { useIntl } from "react-intl";
import {
  GivenNameField,
  FamilyNameField,
  EmailField
} from "../../shared/fields";
import messages from "../../../../shared-messages";

const NonCoppaUpdateUserFormFields = () => {
  const { formatMessage } = useIntl();
  return (
    <>
      <GivenNameField isRequired={false} />
      <FamilyNameField />
      <EmailField
        id={"primary-email"}
        className={"primary-email"}
        name={"primaryEmail"}
        isRequired={false}
        description={formatMessage(messages.emailUseDescription)}
      />
    </>
  );
};

export default NonCoppaUpdateUserFormFields;
